/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.2.13",
    versionName: "0.2.0-nightly.2026.2.13",
    versionChannel: "nightly",
    buildDate: "2026-02-13T00:12:04.363Z",
    commitHash: "1b24dd3a6925eecdd1d7fa49e165814e7ed2163d",
};
